export default "__VITE_ASSET__3e62de8d__"